import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment from 'moment';

@Component({
    selector: 'app-voucher-report',
    templateUrl: './voucher-report.component.html',
    styleUrls: ['./voucher-report.component.css']
})
export class VoucherReportComponent implements OnInit {

    SearchBankAccName = '';
    TotalDebit = 0;
    TotalCredit = 0;
    constructor(private accService: AccountingService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }
    ClearSearch() {
        this.PaymentModelSearch.AccID = 0;
        this.PaymentModelSearch.FromDate = moment(Date.now()).format("DD-MMM-YYYY");
        this.PaymentModelSearch.ToDate = moment(Date.now()).format("DD-MMM-YYYY");
        this.SearchBankAccName = '';
        this.TotalDebit = 0;
        this.TotalCredit = 0;
    };
    PaymentModelSearch = {
        AccountGroupID: '0',
        AccID: 0,
        FromDate: moment(Date.now()).format("DD-MMM-YYYY"),
        ToDate: moment(Date.now()).format("DD-MMM-YYYY"),
        Print: '',
        VoucherType: "",
        VoucherName: ""
    };
    loadingSearch = false;
    VoucherReportList=[];
    GetVoucherReport() {
        this.TotalDebit = 0;
        this.TotalCredit = 0;
        this.PaymentModelSearch.Print = "";
        if (this.PaymentModelSearch.VoucherType != "") {
            this.loadingSearch = true;
            this.spinnerService.show()
            this.PaymentModelSearch.FromDate= this.PaymentModelSearch.FromDate !=null && this.PaymentModelSearch.FromDate!=''?moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY'):'';
            this.PaymentModelSearch.ToDate= this.PaymentModelSearch.ToDate!=null && this.PaymentModelSearch.ToDate!=''?moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY'):'';
            this.accService.GetVoucherReport(JSON.stringify(this.PaymentModelSearch)).subscribe((response) => {
                this.VoucherReportList = response.VoucherReportList;
                if (this.VoucherReportList.length > 0) {
                    this.TotalDebit = 0;
                    this.TotalCredit = 0;
                    for (var i = 0; i < this.VoucherReportList.length; i++) {
                        this.TotalDebit = this.TotalDebit + this.VoucherReportList[i].DebitAmt;
                        this.TotalCredit = this.TotalCredit + this.VoucherReportList[i].CreditAmt;

                    }
                }
                setTimeout(() => {
                    this.spinnerService.hide()
                    this.loadingSearch = false;
                    this.globalHelper.CheckActionStatus(response);
                }, 10);
            });
        }
    };
    VoucherTypeList: any;
    GetVoucherReportPrint() {
        if (this.PaymentModelSearch.VoucherType != "") {
            for (var i = 0; i < this.VoucherTypeList.length; i++) {
                if (this.VoucherTypeList[i].ItemCode1 == this.PaymentModelSearch.VoucherType) {
                    this.PaymentModelSearch.VoucherName = this.VoucherTypeList[i].ItemName;
                }
            }
            this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
            this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
          
            var url = "voucherreportprint?ReportType=PrintVoucherReport&FromDate=" + this.PaymentModelSearch.FromDate + "&ToDate=" + this.PaymentModelSearch.ToDate + "&VoucherType=" + this.PaymentModelSearch.VoucherType + "&VoucherName=" + this.PaymentModelSearch.VoucherName;
            this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

        }
    }
    loadingXMLSearch = false;
    FilePath: any;
    GetVoucherReportXLS() {
        if (this.PaymentModelSearch.VoucherType != "") {
            this.loadingXMLSearch = true;
            this.PaymentModelSearch.Print = "XLS";
            for (var i = 0; i < this.VoucherTypeList.length; i++) {
                if (this.VoucherTypeList[i].ItemCode1 == this.PaymentModelSearch.VoucherType) {
                    this.PaymentModelSearch.VoucherName = this.VoucherTypeList[i].ItemName;
                }
            }
            this.spinnerService.show();
            this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
            this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
          
            this.accService.GetVoucherReport(JSON.stringify(this.PaymentModelSearch)).subscribe((data) => {
                this.FilePath = data.FilePath;
                window.location = data.FilePath;
                this.loadingXMLSearch = false;
                this.spinnerService.hide();
            });
        }
    };
    GetVoucherType() {

        this.lookupService.GetLookupsList('VoucherTypePost', '').subscribe((data) => {

            this.VoucherTypeList = data.LookupItems;

        });
    }


    ngOnInit() {
        setTimeout(() => {
     
            this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");
      
            this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");
                 
          }, 300);
        this.GetVoucherType();
    }

}
